module.exports = __webpack_public_path__ + "img/smm-logo.244731c1.png";